<script setup lang="ts">
import { computed } from 'vue'
import { useClipboard } from '@vueuse/core'
import { VIcon } from '@/modules/shared/components'

const props = defineProps<{
  subdomain: string
  description?: string
}>()

const groupUrl = computed(() => {
  if (!props.subdomain) return ''
  return `${props.subdomain}.venture360.co`
})

const { copy, copied } = useClipboard({ source: groupUrl })

const copyUrl = () => {
  copy(groupUrl.value)
}
</script>

<template>
  <div v-if="subdomain" class="rounded-[10px] border border-[#3D8A9D]/20 bg-[#3D8A9D]/5 px-4 py-3.5">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Your investor portal URL</p>
        <p class="mt-1 text-[15px] font-semibold text-[#3D8A9D]">{{ groupUrl }}</p>
      </div>
      <button
        type="button"
        @click="copyUrl"
        class="mt-1 flex shrink-0 items-center gap-1.5 rounded-md bg-white px-2.5 py-1.5 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-200 transition-colors hover:bg-gray-50"
      >
        <VIcon :name="copied ? 'Check' : 'Copy'" class="h-3.5 w-3.5" />
        <span>{{ copied ? 'Copied!' : 'Copy' }}</span>
      </button>
    </div>
    <p v-if="description" class="mt-1.5 text-[11px] leading-relaxed text-gray-400">{{ description }}</p>
  </div>
</template>
